export default __webpack_public_path__ + "static/Slashdot-225e818e164a26dae1f8938679dc4260.webp";